import { useState, useEffect, useCallback } from "react";
import POPUP from "components/popup";
import api from "services/api";
import { getcodCidade } from "functions/gettabconfig";
import config from "config";
import IMAGEM from "components/imagem";
import { formatDate, formatNumber, maskName } from "components/formatos";
import Avaliacao from "components/avaliacao";
import MostraEstrelas from "components/mostraestrelaas";
import './style.css';
import Promocao from "components/promocao";

function DIALOGLOJADETALHE(props) {
    function Close() {
        props.setTrigger(false);
    }
    const [promocoes, setPromocoes] = useState([]);
    const [ppavalisar, setPpavalisar] = useState(false);
    const [avaliacoes, setAvaliacoes] = useState([]);
    const [pplistaavaliacoes, setPplistaavaliacoes] = useState(false);

    // Função para buscar promoções
    const getAvaliacoes = useCallback(async () => {
        try {
            api.get(`/v1/avaliacoes/${props.dados.id_estabelecimento}`)
                .then(response => {
                    setAvaliacoes(response.data);
                });
        } catch (error) {
            console.error("Erro ao carregar avaliacoes:", error);
        }
    }, [props.dados.id_estabelecimento]);

    const getPromocoes = useCallback(async () => {
        try {
            api.get(`${config.PROMOCOES}/${props.dados.id_estabelecimento}?cod_cidade=${getcodCidade()}`)
                .then(response => {
                    setPromocoes(response.data);
                });
        } catch (error) {
            console.error("Erro ao carregar promoções:", error);
        }
    }, [props.dados.id_estabelecimento]);

    // Função para abrir URL
    const abrirUrl = (link) => {
        if (link) {
            window.open(link, "_blank");
        } else {
            console.error("URL inválida");
        }
    };

    useEffect(() => {
        if (props.trigger) {
            getPromocoes();
            getAvaliacoes();
        }
    }, [props.trigger, getPromocoes, getAvaliacoes]);

    useEffect(() => {
        if (props.trigger) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [props.trigger]);

    return <POPUP
        trigger={props.trigger}
        setTrigger={Close}>

        <div className="loja-detalhe">

            <div className="loja-detalhe-header">
                {props.dados?.url_foto && props.dados.url_foto !== '' && !props.dados.url_foto.endsWith('/') && (
                    <div className="loja-logo-container">
                        <IMAGEM
                            participantes={true}
                            src={`${config.BASEIMG}/${props.dados.url_foto}`}
                            className="loja-imagem"
                        />
                    </div>
                )}
                
                <div className="loja-header-content">
                    <h2 className="loja-nome">{props.dados.nome_estabelecimento}</h2>
                    {!ppavalisar && !pplistaavaliacoes && (
                        <div className="loja-header-meta">
                            <div className="loja-avaliacao-summary" onClick={() => setPplistaavaliacoes(true)}>
                                <div className="stars-badge">
                                    <i className="fas fa-star"></i>
                                    <span>{formatNumber(props.dados.avaliacao, 1)}</span>
                                </div>
                                {avaliacoes.resumo && (
                                    <span className="total-avaliacoes">
                                        ({avaliacoes.resumo.nro_avaliacoes} avaliações)
                                    </span>
                                )}
                            </div>
                            <button type="button"
                                className="btn-avaliar"
                                onClick={() => setPpavalisar(true)}>
                                <i className="fas fa-pen"></i>
                                AVALIAR
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {!ppavalisar && !pplistaavaliacoes && (
                <div className="loja-content">
                    <div className="loja-info-card">
                        <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <p>{props.dados.endereco}</p>
                        </div>
                        <div className="info-item">
                            <i className="fas fa-phone"></i>
                            <p>{props.dados.telefone}</p>
                        </div>

                        <div className="loja-buttons-grid">
                            <a
                                href={`https://wa.me/${(props.dados?.whatsup || "").replace(/\D/g, '')}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-whatsapp"
                            >
                                <i className="fab fa-whatsapp"></i>
                                WhatsApp
                            </a>
                            {props.dados.site && (
                                <button
                                    onClick={() => abrirUrl(props.dados.site)}
                                    className="btn-site">
                                    <i className="fas fa-globe"></i>
                                    Acesse o Site
                                </button>
                            )}
                        </div>
                    </div>

                    {avaliacoes.resumo && (
                        <div className="loja-stats-section">
                            <h3 className="section-subtitle">Resumo de Avaliações</h3>
                            <MostraEstrelas
                                total={avaliacoes.resumo.nro_avaliacoes ?? 0}
                                cinco={avaliacoes.resumo.estrelas5 ?? 0}
                                quatro={avaliacoes.resumo.estrelas4 ?? 0}
                                tres={avaliacoes.resumo.estrelas3 ?? 0}
                                dois={avaliacoes.resumo.estrelas2 ?? 0}
                                um={avaliacoes.resumo.estrelas1 ?? 0}
                            />
                        </div>
                    )}

                    {promocoes.length > 0 && (
                        <div className="loja-promocoes-section">
                            <h3 className="section-subtitle">Promoções Ativas</h3>
                            <div className="loja-promocoes-scroll">
                                {promocoes.map(b => (
                                    <div key={`promo${b.id_promocao}`} className="promocao-scroll-item">
                                        <Promocao promocao={b} index={b.id_promocao} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}

            {ppavalisar && (
                <div className="loja-avaliacao-section">
                    <Avaliacao
                        dados={props.dados}
                        setTrigger={setPpavalisar}
                    />
                </div>
            )}

            {pplistaavaliacoes && (
                <div className="loja-avaliacao-listas">
                    <div className="lista-header">
                        <h2>Avaliações da Loja</h2>
                        <button type="button"
                            onClick={() => setPplistaavaliacoes(false)}
                            className="btn-voltar">
                            <i className="fas fa-arrow-left"></i>
                            Voltar
                        </button>
                    </div>

                    <div className="avaliacoes-grid">
                        {avaliacoes.itens.map((a, index) => (
                            <div key={index} className="avaliacao-card">
                                <div className="avaliacao-card-header">
                                    <div className="user-info">
                                        <div className="user-avatar">
                                            {maskName(a.nomeusuario).charAt(0)}
                                        </div>
                                        <div>
                                            <span className="user-name">{maskName(a.nomeusuario)}</span>
                                            <span className="avaliacao-date">{formatDate(a.datahora)}</span>
                                        </div>
                                    </div>
                                    <div className="stars-display">
                                        {Array.from({ length: 5 }, (_, i) => (
                                            <i key={i} className={`fa-star ${i < a.nro_estrelas ? 'fas' : 'far'}`}></i>
                                        ))}
                                    </div>
                                </div>
                                <div className="avaliacao-comment">
                                    <p>{a.den_avaliacao}</p>
                                </div>
                                {a.den_resposta && (
                                    <div className="avaliacao-resposta">
                                        <span className="resposta-label">Resposta do Estabelecimento:</span>
                                        <p>{a.den_resposta}</p>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    </POPUP>
}

export default DIALOGLOJADETALHE;